import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import ModalContent from '../../Modal/ModalContent/index.esm.js';
import '../../Modal/index.esm.js';
import { useDrawerContext } from '../context.esm.js';

var DrawerContent = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useDrawerContext = useDrawerContext(),
      placement = _useDrawerContext.placement;

  return React__default.createElement(ModalContent, _extends({
    ref: ref,
    unstyled: true,
    margin: placement === 'right' ? 'ml-auto' : undefined,
    flex: "flex-1",
    enter: ['ease-in-out', 'duration-500'],
    enterFrom: placement === 'right' ? 'translate-x-full' : '-translate-x-full',
    enterTo: "translate-x-0",
    leave: ['ease-in-out', 'duration-500'],
    leaveFrom: "translate-x-0",
    leaveTo: placement === 'right' ? 'translate-x-full' : '-translate-x-full'
  }, props));
});

if (__DEV__) {
  DrawerContent.displayName = 'DrawerContent';
}

export default DrawerContent;
//# sourceMappingURL=index.esm.js.map
